.rowClickable {
  cursor: pointer;

  &:hover {
    background-color: light-dark(
      var(--mantine-color-gray-1),
      var(--mantine-color-gray-10)
    );
  }
}
